import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//icons
import AdminIcon from "@/assets/icons/admin/admin.svg?react";
import Addresses from "@/assets/icons/common/addresses.svg?react";
import Fairs from "@/assets/icons/common/fairs.svg?react";
import Home from "@/assets/icons/common/home.svg?react";
import ToursIcon from "@/assets/icons/common/tours.svg?react";
import CoversIcon from "@/assets/icons/common/video.svg?react";
import Wines from "@/assets/icons/common/wines.svg?react";
import { userStore } from "@/stores/UserStore";
import { IconStarFilled } from "@tabler/icons-react";

export const useStoreMenu = () => {
  const [defaultWidth, setDefaultWidth] = useState<string>("var(--left-menu-default-width)");
  const [activePath, setActivePath] = useState<string>("");
  const [handleClickPath, setHandleClickPath] = useState<string>("");
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const refMenu = useRef<HTMLDivElement>(null);
  const refArrow = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userStore.isAdmin && location.pathname.startsWith("/adminPanel")) {
      navigate("/");
    }
  }, [userStore.isAdmin, location.pathname, navigate]);

  // Массив ссылок
  const links = [
    { path: "/", icon: <Home />, label: "Главная" },
    { path: "/wines", icon: <Wines />, label: "Вино \\ Товары" },
    { path: "/fairs", icon: <Fairs />, label: "События" },
    { path: "/addresses", icon: <Addresses />, label: "Адреса" },
    { path: "/tours", icon: <ToursIcon />, label: "Туры" },
    { path: "/video_pages", icon: <CoversIcon />, label: "Видеообложки страниц" },
    { path: "/reviews", icon: <IconStarFilled />, label: "Отзывы" },
  ];

  if (userStore.isAdmin) {
    links.push({ path: "/adminPanel", icon: <AdminIcon />, label: "Панель Администратора" });
  }

  // СИНХРОННО определяем активную ссылку при изменении пути
  useLayoutEffect(() => {
    if (firstLoad) {
      //eslint-disable-next-line
      setFirstLoad((prev) => !prev);
    }
    const activeLink = links.find(
      (link) =>
        location.pathname === link.path || (link.path !== "/" && location.pathname.startsWith(link.path)),
    );

    if (activeLink) {
      const linkElement = document.querySelector(`[href="${activeLink.path}"]`) as HTMLAnchorElement;
      if (linkElement && refArrow.current) {
        const positionTop = linkElement.getBoundingClientRect().top;
        const hElement = linkElement.clientHeight;
        refArrow.current.style.top = `${positionTop}px`;
        refArrow.current.style.height = `${hElement}px`;
      }
    }
  }, [location.pathname]);

  function endTransition(e: TransitionEvent) {
    if (e.propertyName === "top") {
      // refArrow.current!.classList.remove(styles.transition);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          navigate(handleClickPath);
        });
      });
    }
  }

  useEffect(() => {
    const el = refArrow.current;
    if (!el) return;

    el.addEventListener("transitionend", endTransition);

    return () => {
      el.removeEventListener("transitionend", endTransition);
    };
  }, [handleClickPath]);

  const handleMouseEnter = () => {
    if (refMenu.current) {
      const contentWidth = refMenu.current.scrollWidth;
      setDefaultWidth(`${contentWidth}px`);
    }
  };

  const handleMouseLeave = () => {
    setDefaultWidth("var(--left-menu-default-width)");
  };

  const handleLinkClick = (path: string, element: HTMLAnchorElement, e: React.MouseEvent) => {
    e.preventDefault();
    setActivePath(path);
    setHandleClickPath(path);
    refArrow.current!.style.transition = "top .3s ease-in-out";
    const positionTop = element.getBoundingClientRect().top;
    if (refArrow.current) {
      refArrow.current.style.top = `${positionTop}px`;
    }
  };

  return {
    defaultWidth,
    setDefaultWidth,
    activePath,
    setActivePath,
    firstLoad,
    setFirstLoad,
    refMenu,
    refArrow,
    location,
    links,
    handleMouseEnter,
    handleMouseLeave,
    handleLinkClick,
    endTransition,
  };
};
